import { render, staticRenderFns } from "./termsConditionsEdition.vue?vue&type=template&id=4bccebd1"
import script from "./termsConditionsEdition.vue?vue&type=script&lang=js"
export * from "./termsConditionsEdition.vue?vue&type=script&lang=js"
import style0 from "./termsConditionsEdition.vue?vue&type=style&index=0&id=4bccebd1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports